var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-pull-to-refresh',{on:{"refresh":_vm.setWayBillList}},[_c('WayBillList',{attrs:{"filter":_vm.filter,"items":_vm.items,"title":"لیست بارنامه های صادر شده تا کنون","show-all":true,"available-items":[]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }